import '../css/index.scss'
import $ from 'jquery'
import { setupLenis } from "../scripts/lenis.js";

const setup = () => {
  // 設定を行ったLenisのインスタンスを作成
  const lenis = setupLenis();

  // アンカーリンクを取得
  const anchors = document.querySelectorAll('.nav-item-link');
  anchors.forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      lenis.scrollTo( '#' + this.getAttribute('data-target'))
    });
  })
};

setup();

/**js**/
'use strict';

var windowWidth = $(window).width();
var windowHeight = $(window).height();
var BREAKPOINT_SP = 768;
var adjust = null;

window.addEventListener('load',function(){

  let vw = window.innerWidth;
  let vh = window.innerHeight * 0.01;

  document.documentElement.style.setProperty('--vw', `${vw}px`);
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  if (windowWidth <= BREAKPOINT_SP) {
    adjust = windowHeight * .25;
  } else {
    adjust = windowHeight * .15;
  }

  const body = document.querySelector( 'body' );
  setTimeout(() => {
    body.classList.add('opening');
    setTimeout(() => {
      body.classList.add('complete');
      body.classList.remove('opening');
    }, 4200);
  }, 300);

});


// resize
var resizeTimer;
var interval = 1000;

window.addEventListener('resize', function() {

  if (resizeTimer !== false) {
    clearTimeout(resizeTimer);
  }

  resizeTimer = setTimeout(function() {
    windowHeight = $(window).height();

    let vw = window.innerWidth;
    let vh = window.innerHeight * 0.01;

    document.documentElement.style.setProperty('--vw', `${vw}px`);
    document.documentElement.style.setProperty('--vh', `${vh}px`);

  }, interval);

});

$(function(){

  // animate
  var current_scrollY;
  current_scrollY = $( window ).scrollTop();
  triggerAnimation(current_scrollY);
  triggerDrawerBtn(current_scrollY);

  $(window).on('scroll', function () {
    current_scrollY = $( window ).scrollTop();
    triggerAnimation(current_scrollY);
    triggerDrawerBtn(current_scrollY);
  });

  function triggerAnimation(scroll) {
    const scrollBottom = scroll + $(window).height();
    $('.animate').each(function() {
      const top = $(this).offset().top + adjust;
      if(scrollBottom > top) {
        $(this).addClass('is_animated');
      } else {
        // $(this).removeClass('is_animated');
      }
    })
  }

  function triggerDrawerBtn(scroll) {
    const DrawerBtn = $(".js-drawer-nav");
    const scrollPos = scroll;
    if (scrollPos > 100) {
      DrawerBtn.addClass('is_active');
    } else {
      DrawerBtn.removeClass('is_active');
    }
  }

  /*----------------------------------------------------------
    drawer-nav
  ----------------------------------------------------------*/

  var gNavi = $('.drawer-nav');
  var gNaviButton = $('.js-drawer-nav');

  gNaviButton.on('click', function(){
    $('body').toggleClass('is-open');
  });

  $('.drawer-nav button').on('click', function(){
    $('body').toggleClass('is-open');
  });

  /*----------------------------------------------------------
    #archive (more)
  ----------------------------------------------------------*/

  var defaultNum = 3;
  var moreNum = 6;

  $('.c-post__list article:nth-child(n + ' + (defaultNum + 1) + ')').addClass('is-hidden');

  if ($('.c-post__list article').length < defaultNum) {
    $('.js-viewmore').fadeOut();
  }

  $('.js-viewmore').on('click', function() {
    // $('.c-post__list article.is-hidden').slice(0, moreNum).removeClass('is-hidden'); // 表示数を指定する場合
    $('.c-post__list article.is-hidden').removeClass('is-hidden'); // すべて表示する
    if ($('.c-post__list article.is-hidden').length == 0) {
      $('.js-viewmore').fadeOut();
    }
  });

});


/*----------------------------------------------------------
  #inquiry (accordion)
----------------------------------------------------------*/

const slideDown = function(el) {
  el.style.height = 'auto';
  let h = el.offsetHeight;
  el.animate({
    height: [ 0, h + 'px' ]
  }, {
    duration: 300,
  });
  el.style.height = 'auto';
  el.setAttribute('aria-hidden', 'false');
};

const slideUp = function(el) {
  let h = el.offsetHeight;
  el.style.height = h + 'px';
  el.animate({
    height: [ h + 'px', 0]
  }, {
    duration: 300,
  });
  el.style.height = 0;
  el.setAttribute('aria-hidden', 'true');
};

let activeIndex = null;

const accordions = document.querySelectorAll('.include-accordion');
accordions.forEach(function (accordion) {

  const accordionBtns = accordion.querySelectorAll('.js-accordionBtn');
  accordionBtns.forEach( function(accordionBtn, index) {
    accordionBtn.addEventListener('click', function(e) {
      activeIndex = index;
      const isActive = e.target.parentNode.classList.toggle('active');
      accordionBtn.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      const content = accordionBtn.nextElementSibling;
      if (isActive) {
        slideDown(content);
      }else{
        slideUp(content);
      }
      accordionBtns.forEach( function(accordionBtn, index) {
        if (activeIndex !== index) {
          accordionBtn.parentNode.classList.remove('active');
          accordionBtn.setAttribute('aria-expanded', 'false');
          const openedContent = accordionBtn.nextElementSibling;
          slideUp(openedContent);
        }
      });
    });
  });
});

/*----------------------------------------------------------
  swiper
----------------------------------------------------------*/

const swiperSeminarThumb = new Swiper(".seminar-schedule .schedule-thumb", {
  slidesPerView: 'auto',
  freeMode: true,
  watchSlidesProgress: true,
  pagination: {
    el: ".seminar-schedule .schedule-thumb .swiper-pagination",
    type: "progressbar",
  },
  breakpoints: {
    769: {
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 18
    },
  },
});

const swiperSeminarMain = new Swiper(".seminar-schedule .schedule-main", {
  slidesPerView: 1.15,
  slidesPerGroup: 1,
  spaceBetween: 16,
  grabCursor: true,
  pagination: {
    el: ".seminar-schedule .schedule-main .swiper-pagination",
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + (index + 1) + "</span>";
    },
  },
  navigation: {
    nextEl: '.seminar-schedule .schedule-main .swiper-button-next',
    prevEl: '.seminar-schedule .schedule-main .swiper-button-prev',
  },
  breakpoints: {
    769: {
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 18,
    },
  },
  thumbs: {
    swiper: swiperSeminarThumb,
  },
});

const swiperCourseThumb = new Swiper(".course-schedule .schedule-thumb", {
  slidesPerView: 'auto',
  freeMode: true,
  watchSlidesProgress: true,
  pagination: {
    el: ".course-schedule .schedule-thumb .swiper-pagination",
    type: "progressbar",
  },
  breakpoints: {
    769: {
      slidesPerView: 1,
      slidesPerGroup: 1,
    },
  },
});

const swiperCourseMain = new Swiper(".course-schedule .schedule-main", {
  slidesPerView: 1.15,
  spaceBetween: 16,
  grabCursor: true,
  pagination: {
    el: ".course-schedule .schedule-main .swiper-pagination",
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + (index + 1) + "</span>";
    },
  },
  navigation: {
    nextEl: '.course-schedule .schedule-main .swiper-button-next',
    prevEl: '.course-schedule .schedule-main .swiper-button-prev',
  },
  breakpoints: {
    769: {
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 18
    },
  },
  thumbs: {
    swiper: swiperCourseThumb,
  },
});

const swiperVoice = new Swiper(".voices__list .voice-main", {
  slidesPerView: 1.15,
  spaceBetween: 16,
  grabCursor: true,
  navigation: {
    nextEl: '.voices__list .swiper-button-next',
    prevEl: '.voices__list .swiper-button-prev',
  },
  pagination: {
    el: ".voices__list .swiper-pagination",
    type: "progressbar",
  },
  breakpoints: {
    769: {
      slidesPerView: 4,
      slidesPerGroup: 4,
      spaceBetween: 18
    },
  },
});
